import { render, staticRenderFns } from "./RelatorioLogGrupo.vue?vue&type=template&id=9b2af066&scoped=true"
import script from "./RelatorioLogGrupo.vue?vue&type=script&lang=js"
export * from "./RelatorioLogGrupo.vue?vue&type=script&lang=js"
import style0 from "./RelatorioLogGrupo.vue?vue&type=style&index=0&id=9b2af066&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9b2af066",
  null
  
)

export default component.exports